/* import React from "react"; */
import { Link, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import HomeVideo from "./HomeVideo";


const AboutChaashni = () => {


   const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);


  const desktopRef = useRef(null);
   const mobileRef = useRef(null);
  
    useEffect(() => {
      const isMobile = window.innerWidth <= 768; // adjust as needed
  
      const playVideo = () => {
        const video = isMobile ? mobileRef.current : desktopRef.current;
        if (video) {
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch((err) => {
              console.warn('Autoplay error:', err);
            });
          }
        }
      };
  
      if (document.readyState === 'complete') {
        setTimeout(playVideo, 100); // short delay improves iOS behavior
      } else {
        window.addEventListener('load', () => setTimeout(playVideo, 100));
      }
    }, []);
  return (
    <div className="about-chaashni-full" style={{"display":"none"}}>
      <div className="container">
        <h2 className="newfont-heading">About Chaashni & the फाउंडर्स{/* ABOUT CHAASHNI & THE FOUNDERS */}</h2>
        <p>Founded by Maansi and Ketan, Chaashni is a passion project rooted in elegance and artistry.<br />
          Together, they create pieces that embody grace and craftsmanship, making every garment a cherished experience.</p>
        <p>Here's more about them and the team behind Chaashni.</p>

        <ul className="about-section">
          
          <li>
          <Link to="/aboutchaashni#peopleofchaashni"><img src="/images/about/the-people-chaashni.jpg" alt="The People of Chaashni" /></Link>
            <p><Link to="/aboutchaashni#peopleofchaashni">The People of Chaashni</Link></p>
          </li>
          <li>
            <Link to="/aboutchaashni#maansiketan"><img src="/images/about/maansiandketan.jpg" alt="MaansiAndKetan" /></Link>
            <p><Link to="/aboutchaashni#maansiketan">About Maansi & Ketan</Link></p>
          </li>
          <li>            
            <Link to="/clientdiaries"><img src="/images/about/chaashni-women.jpg" alt="The Women Chaashni" /></Link>
            <p><Link to="/clientdiaries">The Women of Chaashni  - Our customers, Our pride.</Link></p>
          </li>
          {/* <li className="store-wrap">
            <div className="store-box"><Link to="/#newdelhi"><img src="/images/delhi-showroom.jpg" alt="The Experience Center
New Delhi" /></Link>
            <p><Link to="/#newdelhi">The Experience Center, New Delhi</Link></p></div>
            <div className="store-box"><Link to="/#dubai"><img src="/images/dubai-showroom.jpg" alt="dubai-showroom" /></Link>
            <p><Link to="/#dubai">The Gulf Flagship, Dubai </Link></p></div>            
          </li> */}
        </ul>
         

              <HomeVideo />


      </div>
    </div>
  );
};

export default AboutChaashni;
